import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  myProfile: [],
}

export const userSettingReducer = createSlice({
  name: 'userSettingReducer',
  initialState,
  reducers: {
    setMyProfile: (state, action) => {
      state.myProfile = action.payload
    },

  },
})

export const { setMyProfile } = userSettingReducer.actions

export default userSettingReducer.reducer
